import { Controller } from "@hotwired/stimulus"
import jquery from "jquery"
import select2 from "select2"

// The webhook endpoint form's "Which events?" control. Owns two things:
//
//   1. An "All events" / "Specific events" toggle. "All events" means an empty
//      event_type_ids set, which the backend treats as "every event, including
//      ones we add later" — so it's the future-proof default, not a select-all
//      of today's options. Picking "Specific" reveals the multi-select.
//   2. A select2 multi-select whose DROPDOWN options show the event name with
//      its description on a smaller second line, while the SELECTED chips show
//      the name only.
//
// We don't reuse BT's shared `fields--super-select` controller because its
// option template is single-line and shared between the dropdown and the chips,
// and it has no notion of the all/specific toggle.
export default class extends Controller {
  static targets = ["select", "picker", "allRadio"]

  initialize() {
    if (window.jQuery === undefined) window.jQuery = jquery
    if (window?.jQuery?.fn?.select2 === undefined) select2()
  }

  connect() {
    const el = this.hasSelectTarget ? this.selectTarget : this.element
    this.$select = jquery(el)
    this.$select.select2({
      dropdownParent: jquery(this.element),
      // width:'100%' (not 'style') so the box sizes correctly even when it
      // starts hidden under the "All events" mode.
      width: "100%",
      minimumResultsForSearch: -1,
      templateResult: this.formatResult,
      templateSelection: this.formatSelection,
    })
    this.syncPicker()
  }

  disconnect() {
    if (this.$select) this.$select.select2("destroy")
  }

  // Fired by either radio's change. Show the picker only in "Specific" mode;
  // entering "All" clears any specific picks so the form submits an empty set.
  toggle() {
    this.syncPicker()
  }

  syncPicker() {
    const allSelected = this.hasAllRadioTarget && this.allRadioTarget.checked
    if (this.hasPickerTarget) this.pickerTarget.classList.toggle("hidden", allSelected)
    if (allSelected && this.$select) this.$select.val(null).trigger("change")
  }

  // Dropdown row: event name, then its description in smaller muted text.
  // `.text()` escapes, so option content is never injected as HTML.
  formatResult(option) {
    if (!option.element) return option.text
    const row = jquery("<div>")
    jquery("<div>").addClass("font-medium").text(option.text).appendTo(row)
    const description = option.element.dataset.description
    if (description) {
      jquery("<div>")
        .addClass("text-xs text-base-500 dark:text-base-400 mt-0.5 whitespace-normal")
        .text(description)
        .appendTo(row)
    }
    return row
  }

  // Selected chip: just the event name.
  formatSelection(option) {
    return option.text
  }
}
